import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SettingsState } from './settings.state';

export const selectSettingsState =
  createFeatureSelector<SettingsState>('settings');

export const selectSettings = createSelector(
  selectSettingsState,
  (state) => state.settings
);

export const selectSettingsLoading = createSelector(
  selectSettingsState,
  (state) => state.loading
);

export const selectSettingsError = createSelector(
  selectSettingsState,
  (state) => state.error
);

// Selectors spécifiques pour faciliter l'accès aux données
export const selectGeneralSettings = createSelector(
  selectSettings,
  (settings) => settings?.general
);

export const selectNotificationsSettings = createSelector(
  selectSettings,
  (settings) => settings?.notifications
);

export const selectSecuritySettings = createSelector(
  selectSettings,
  (settings) => settings?.security
);

export const selectPassportMenu = createSelector(
  selectSettings,
  (settings) => settings?.menus?.passportMenu
);

export const selectPatientRecordForms = createSelector(
  selectSettings,
  (settings) => settings?.forms?.patientRecord
);

export const selectEnableRegistration = createSelector(
  selectGeneralSettings,
  (general) => general?.enableRegistration ?? true
);
